import { render, staticRenderFns } from "./SelectSlatCategory.vue?vue&type=template&id=77ef8430&scoped=true&"
import script from "./SelectSlatCategory.vue?vue&type=script&lang=js&"
export * from "./SelectSlatCategory.vue?vue&type=script&lang=js&"
import style0 from "./SelectSlatCategory.vue?vue&type=style&index=0&id=77ef8430&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ef8430",
  null
  
)

export default component.exports